import { createForm, getData } from "../helpers";

class ChangeStatus extends HTMLDivElement {
    connectedCallback() {
        this.firstElementChild.addEventListener("click", (e) => {
            const Target = e.target;
            createForm(getData(Target, "data-url"), {
                status: Target.checked ? 1 : 0,
            });
        });
    }
}

window.customElements.define("change-status", ChangeStatus, {
    extends: "div",
});
